import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    StagesetDeactivate as StagesetDeactivateMutation,
    StagesetDeactivateVariables,
    StagesetDeactivateInput,
} from 'nutshell-graphql-types';

import STAGESET_DEACTIVATE from '../mutations/stageset-deactivate.graphql';
import GET_STAGESETS from '../queries/get-stagesets-for-pipeline-list.graphql';

export const useStagesetDeactivate = (): {
    stagesetDeactivate: (arg1: StagesetDeactivateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [stagesetDeactivate, {loading, error}] = useMutation<
        StagesetDeactivateMutation,
        StagesetDeactivateVariables
    >(STAGESET_DEACTIVATE);

    return {
        stagesetDeactivate: (input: StagesetDeactivateInput) =>
            stagesetDeactivate({variables: {input}, refetchQueries: [{query: GET_STAGESETS}]}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
